/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Layout } from '@/data/types/Layout';

export const getRevokeOrderPage = (): Layout => ({
	name: 'Aside',
	slots: {
		header: [{ name: 'Header', id: 'header' }],
		aside: [{ name: 'AccountSidebar', id: 'side_bar' }],
		first: [{ name: 'BreadcrumbTrail', id: 'breadcrumb-trail-widget' }],
		second: [{ name: 'RevokeOrder', id: 'revoke_order' }],
		third: [{ name: 'MyAccountFooter', id: 'my_account_footer' }],
		footer: [{ name: 'Footer', id: 'footer' }],
	},
});
